import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class SharedService {

  _isToggleS = new Subject<any>();
  isToggle = this._isToggleS.asObservable();

  _isImportedS = new Subject<any>();
  isImported = this._isImportedS.asObservable();

  _isCompletedS = new Subject<any>();
  isCompleted = this._isCompletedS.asObservable();

  constructor() { }

  refresh(val: boolean) {
    this._isToggleS.next(val);
  }

  isImport(val: boolean) {
    this._isImportedS.next(val);
  }

  isComplete(val: boolean) {
    this._isCompletedS.next(val);
  }

}
